import React from "react";

import { Typography } from "@mui/material";

export const ThamesCombinedLongDescription = () => {
  return (
    <>
      <Typography variant="body1" paragraph>
        Many parts of inner London have sewer systems that carry rainwater as
        well as sewage. These Victorian 'combined sewer systems' were designed
        for a city of four milion people. But with sewage from almost nine
        million people, the network is now at 80 per cent or more of capacity,
        even in dry weather. Data source: Thames Water.
      </Typography>
    </>
  );
};

export const thamesCombinedShortDescription = "Mainly inner London.";
